import { render, staticRenderFns } from "./TemplateKosong.vue?vue&type=template&id=08ce40cc&"
import script from "./TemplateKosong.vue?vue&type=script&lang=js&"
export * from "./TemplateKosong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports